import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['middle-school-june-release'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
